export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-primary-500"></i>
              </div>
              <span className="text-base font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                91樱花动漫
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">
              高清动漫在线观看平台，提供热门动漫全集在线看服务。无需下载，打开浏览器即可流畅追番。每日更新最新动漫在线看资源，为您打造纯净的番剧在线观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</a></li>
              <li><a href="#about" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">品牌介绍</a></li>
              <li><a href="#cards" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">热门番剧</a></li>
              <li><a href="#features" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">平台特色</a></li>
              <li><a href="#faq" className="text-xs md:text-sm text-foreground-600 hover:text-primary-500 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              期待与更多优质动漫网站和内容平台建立合作
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-xs md:text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-foreground-500"></i>
                </div>
                <span>91sakura@anime.com</span>
              </li>
              <li className="flex items-center gap-2 text-xs md:text-sm text-foreground-600">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-foreground-500"></i>
                </div>
                <span>安全纯净追番</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 91樱花动漫 - 动漫在线观看与高清动漫全集网站
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">在线看动漫不用下载</span>
          </div>
        </div>
      </div>
    </footer>
  );
}